// Angular
import { RouterModule } from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';

// NgBootstrap
import {NgbDropdownModule, NgbNavModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
// Perfect Scrollbar
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
// Core module
import {CoreModule} from '../../core/core.module';
// CRUD Partials
import {
	ActionNotificationComponent,
	AlertComponent,
	DeleteEntityDialogComponent,
	FetchEntityDialogComponent,
	UpdateStatusDialogComponent,
} from './content/crud';
// Layout partials
import {
	ContextMenu2Component,
	ContextMenuComponent,
	LanguageSelectorComponent,
	NotificationComponent,
	QuickActionComponent,
	QuickPanelComponent,
	ScrollTopComponent,
	SearchDefaultComponent,
	SearchDropdownComponent,
	SearchResultComponent,
	SplashScreenComponent,
	StickyToolbarComponent,
	Subheader1Component,
	Subheader2Component,
	Subheader3Component,
	Subheader4Component,
	Subheader5Component,
	SubheaderSearchComponent,
	UserProfileComponent,
} from './layout';
// General
import {NoticeComponent} from './content/general/notice/notice.component';
import {PortletModule} from './content/general/portlet/portlet.module';
// Errpr
import {ErrorComponent} from './content/general/error/error.component';
// Extra module
import {WidgetModule} from './content/widgets/widget.module';
// SVG inline
import {InlineSVGModule} from 'ng-inline-svg';
import {CartComponent} from './layout/topbar/cart/cart.component';
import { FilterSearchComponent } from './content/shared/filterSearch/filterSearch.component';
import { RedirectComponent } from './content/shared/redirect/redirect.component';
import { FilterSearchChipComponent } from './content/shared/filterSearchChip/filterSearchChip.component';
import { FilterSearchSingleComponent } from './content/shared/filterSearchSingle/filterSearchSingle.component';
import { LoadingService } from './layout/loading-service/loading-service.component';
import { InitialLoaderComponent } from './layout/initial-loader/initial-loader.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ExcelTemplateFilterComponent } from './content/shared/excelTemplateFilter/excelTemplateFilter.component';
import { FilterSearchMultipleComponent } from './content/shared/filterSearchMultiple/filterSearchMultiple.component';
import { FilterSearchMultiSelectComponent } from './content/shared/filterSearchMultiSelect/filterSearchMultiSelect.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search'; 
import { ErrorAlertComponent } from './content/crud/error-alert/error-alert.component';
import { AlertNotificationComponent } from './content/crud/alert-notification/alert-notification.component';
import { ConfirmNotificationComponent } from './content/crud/confirm-notification/confirm-notification.component';
import { FilterSearchWithAnyComponent } from './content/shared/filterSearchWithAny/filterSearchWithAny.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NotificationModeDialogComponent } from './content/shared/notificationModeDialog/notification-mode-dialog.component';
import { FutureDateDialogComponent } from './content/shared/futureDateDialog/future-date-dialog.component';
@NgModule({
	declarations: [
		ScrollTopComponent,
		NoticeComponent,
		ActionNotificationComponent,
		DeleteEntityDialogComponent,
		FetchEntityDialogComponent,
		UpdateStatusDialogComponent,
		AlertComponent,

		// topbar components
		ContextMenu2Component,
		ContextMenuComponent,
		QuickPanelComponent,
		ScrollTopComponent,
		SearchResultComponent,
		SplashScreenComponent,
		StickyToolbarComponent,
		Subheader1Component,
		Subheader2Component,
		Subheader3Component,
		Subheader4Component,
		Subheader5Component,
		SubheaderSearchComponent,
		LanguageSelectorComponent,
		NotificationComponent,
		QuickActionComponent,
		SearchDefaultComponent,
		SearchDropdownComponent,
		UserProfileComponent,

		CartComponent,

		ErrorComponent,

		FilterSearchComponent,
		FilterSearchChipComponent,
		FilterSearchSingleComponent,
		RedirectComponent,
		LoadingService,
		InitialLoaderComponent,
		ExcelTemplateFilterComponent,
		FilterSearchMultipleComponent,
		FilterSearchMultiSelectComponent,

		ErrorAlertComponent,
		AlertNotificationComponent,
		ConfirmNotificationComponent,
		FilterSearchWithAnyComponent,
		NotificationModeDialogComponent,
		FutureDateDialogComponent
		
	],
	exports: [
		WidgetModule,
		PortletModule,
		
		ScrollTopComponent,
		NoticeComponent,
		ActionNotificationComponent,
		DeleteEntityDialogComponent,
		FetchEntityDialogComponent,
		UpdateStatusDialogComponent,
		AlertComponent,
		
		// topbar components
		ContextMenu2Component,
		ContextMenuComponent,
		QuickPanelComponent,
		ScrollTopComponent,
		SearchResultComponent,
		SplashScreenComponent,
		LoadingService,
		StickyToolbarComponent,
		Subheader1Component,
		Subheader2Component,
		Subheader3Component,
		Subheader4Component,
		Subheader5Component,
		SubheaderSearchComponent,
		LanguageSelectorComponent,
		NotificationComponent,
		QuickActionComponent,
		SearchDefaultComponent,
		SearchDropdownComponent,
		UserProfileComponent,
		FilterSearchComponent,
		CartComponent,
		FilterSearchChipComponent,
		FilterSearchSingleComponent,
		ErrorComponent,
		InitialLoaderComponent,
		ExcelTemplateFilterComponent,
		FilterSearchMultipleComponent,
		FilterSearchMultiSelectComponent,
		ErrorAlertComponent,
		AlertNotificationComponent,
		ConfirmNotificationComponent,
		FilterSearchWithAnyComponent,
		NotificationModeDialogComponent,
		FutureDateDialogComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		PerfectScrollbarModule,
		InlineSVGModule,
		CoreModule,
		PortletModule,
		WidgetModule,
		MaterialModule,
		// angular material modules
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
		MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatTabsModule,
		MatTooltipModule,
		MatDialogModule,
		MatChipsModule,

		// ng-bootstrap modules
		NgbDropdownModule,
		NgbNavModule,
		NgbTooltipModule,
		NgxMatSelectSearchModule,
		ScrollingModule
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	entryComponents: [
		NotificationModeDialogComponent,
		DeleteEntityDialogComponent,
		FetchEntityDialogComponent,
		UpdateStatusDialogComponent,
		ConfirmNotificationComponent,
		FutureDateDialogComponent
	]
})
export class PartialsModule {
}
